// extracted by mini-css-extract-plugin
module.exports = {"iconSearch":"IconSearch_iconSearch__14i-G"};